<template>
<div>
  <div class="flex-grow">
    <input
      v-debounce:400ms="updateSearch"
      type="search"
      id="elastic-search-input"
      @search="searchClear"
      :placeholder="placeHolder"
      class="block w-full p-2 pl-8 text-xs border-gray-300 rounded-md shadow focus:border-blue-500 focus:ring-0 md:p-4 md:pl-12 sm:p-3 sm:leading-5 sm:text-sm"
    />
  </div>
  <ul class="mt-4 bg-white">
    <slot name="results" :items="this.searchResults"/>
  </ul>
  <nav class="flex items-center justify-between px-4 py-3 border-t border-gray-200 sm:px-6" aria-label="Pagination">
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        Showing
        <span class="font-medium">{{ this.getPaginationLowerBound() }}</span>
        to
        <span class="font-medium">{{ this.getPaginationUpperBound() }}</span>
        of
        <span class="font-medium">{{ this.total }}</span>
        results
      </p>
    </div>
    <div class="flex justify-between flex-1 sm:justify-end">
      <a v-if="!isFirstPage" @click="decrementPage" class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
        Previous
      </a>
      <a v-if="!isLastPage" @click="incrementPage" class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
        Next
      </a>
    </div>
  </nav>
</div>
</template>

<script>
import { getDirective } from 'vue-debounce'
export default {
  directives: {
    debounce: getDirective()
  },
  props: {
    searchFilters: {
      type: [Array, Object],
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    placeHolder: {
      type: String,
      required: false,
      default: 'Search...',
    },
    model: {
      type: [Array, Object],
      required: true,
    }
  },

  data () {
    return {
      searchResults: {},
      serverParams: {
        searchTerm: '',
        filters: {},
        pageSize: 10,
        page: 0,
      },
      total: 0,
    }
  },
  created(){
    this.sessionFilters();
    this.loadItems();
  },
  computed: {
    isFirstPage() {
      if (this.serverParams.page === 0) {
        return true;
      }
      return false
    },
    isLastPage() {
      var numPages = Math.ceil(this.total/this.serverParams.pageSize);
      if (this.serverParams.page + 1 === numPages) {
        return true;
      }
      return false
    },
    currentTab() {
      var currentUrl = document.URL;
      var urlParts   = currentUrl.split('#');
      if (urlParts.length > 1) {
        return this.activeTab = urlParts[1];
      } 
      return '';
    },
    sessionSlug() {
      return this.model.model_type + this.model.id + this.currentTab
    }
  },
  methods: {
    updateSearch(val, e) {
      this.serverParams.page = 0
      this.serverParams.searchTerm = val
      this.loadItems();
    },
    async loadItems() {
      this.serverParams.filters = this.searchFilters;
      sessionStorage.setItem(this.sessionSlug, JSON.stringify({'searchTerm': this.serverParams.searchTerm, 'page': this.serverParams.page}));
      try {
        const response = await axios.get(this.searchRoute, { params: this.serverParams });
        this.searchResults = response.data.results;
        this.total = response.data.totalRows;
        this.isLoading = false;

      } catch (error) {
        this.rows = [];
        this.isLoading = false;
        return false;
      }

      return true;
    },
    getPaginationLowerBound(){
      return (this.serverParams.page*this.serverParams.pageSize) + 1;
    },
    getPaginationUpperBound(){
      var bound = (this.serverParams.page + 1)*this.serverParams.pageSize;
      if(bound <= this.total){
        return bound;
      } else {
        return this.total;
      }
    },
    incrementPage() {
      this.serverParams.page = this.serverParams.page + 1;
      this.loadItems();
    },
    decrementPage() {
      this.serverParams.page = this.serverParams.page - 1;
      this.loadItems();
    },
    searchClear() {
      if (document.getElementById('elastic-search-input').value === '') {
        this.serverParams.searchTerm = document.getElementById('elastic-search-input').value;
        this.loadItems();
      }
    },
    sessionFilters() {
      if (sessionStorage.getItem(this.sessionSlug)) {
        var params = JSON.parse(sessionStorage.getItem(this.sessionSlug))
        this.serverParams.searchTerm = params.searchTerm;
        this.serverParams.page = params.page;
      }
    }
  }
};
</script>
